<template>
  <header class="header">
    <!-- 主导航栏 -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
      <div class="container">
        <!-- Logo + 公司名称 -->
        <router-link class="navbar-brand d-flex align-items-center" to="/">
          <img src="../assets/vklogo.jpg" alt="Logo" height="40" class="mr-2">
          <!-- 新增公司名称文本 -->
          <span class="company-name">{{ $t('nav.brand') }}</span>
        </router-link>

        <!-- 移动端菜单按钮 -->
        <button 
          class="navbar-toggler" 
          type="button" 
          data-toggle="collapse" 
          data-target="#navbarNav"
          @click="toggleMobileMenu"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- 导航菜单 -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ml-auto align-items-lg-center">
            <li class="nav-item" v-for="item in navItems" :key="item.path">
              <router-link 
                class="nav-link" 
                :to="item.path"
                :class="{ active: $route.path === item.path }"
              >
                {{ $t(item.label) }}
              </router-link>
            </li>
            <li class="nav-item">
              <button class="lang-switch" type="button" @click="toggleLang">
                <i class="fas fa-globe mr-1"></i>{{ $t('nav.switchTo') }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      navItems: [
        { label: 'nav.home', path: '/' },
        { label: 'nav.products', path: '/products' },
        { label: 'nav.news', path: '/news' },
        { label: 'nav.about', path: '/about' }
      ],
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    toggleLang() {
      this.$setLocale(this.$locale === 'en' ? 'zh' : 'en')
    }
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
}


.navbar-brand {
  font-weight: bold;
  font-size: 1.5rem;
  /* 保证Logo和文字垂直居中 */
  align-items: center !important;
}

/* 公司名称样式优化 */
.company-name {
  color: #333;
  font-size: 1.2rem;
  font-weight: 600;
}

.nav-link {
  font-weight: 500;
  margin: 0 0.5rem;
  transition: color 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #007bff !important;
}

.lang-switch {
  margin-left: 0.75rem;
  padding: 0.28rem 0.85rem;
  border: 1px solid #007bff;
  border-radius: 999px;
  background: transparent;
  color: #007bff;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.4;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.lang-switch:hover {
  background: #007bff;
  color: #fff;
}

@media (max-width: 991px) {
  .navbar-nav {
    margin-top: 1rem;
  }
  
  .nav-link {
    padding: 0.75rem 0;
    margin: 0;
    border-bottom: 1px solid #eee;
  }
}

@media (max-width: 576px) {
  .company-name {
    font-size: 1rem;
  }
}
</style>